'use strict';

import template from './mx-dependency-visualizer.html';

angular.module('mx.SolutionBuilderAgent').component('mxDependencyVisualizer', {
	bindings: { dependencyTree: '<', onNodeClick: '&' },
	require: {
		parentViewController: '?^^mxView',
	},
	controller: MxDependencyVisualizerCtrl,
	controllerAs: 'vm',
	template: template,
});

MxDependencyVisualizerCtrl.$inject = ['$scope', '$element', '$q', '$mdIcon', 'mx.internationalization', 'VisDataSet', 'mx.app.ThemeService'];

function MxDependencyVisualizerCtrl($scope, $element, $q, $mdIcon, i18n, VisDataSet, themeService) {
	const vm = this;
	let images = {};
	let currentObject = null;

	vm.i18n = i18n.get('solutionBuilderAgent.components.mx-dependency-visualizer');

	vm.graphOptions = {
		edges: {
			arrows: { to: true },
			smooth: true,
		},
		height: '100%',
		interaction: { hover: true },
		layout: { randomSeed: 1 },
		nodes: {
			size: 80,
			shapeProperties: {
				//disabled interpolation of caching images because algorithm of coordinates has a bug (size of getting rectangle can be bigger than size of canvas in drawImage function) and IE has a problem with it
				interpolation: false,
			},
		},
		physics: {
			maxVelocity: 0,
			minVelocity: 0.01,
			repulsion: {
				centralGravity: 0,
				nodeDistance: 120,
				springConstant: 0,
			},
			solver: 'repulsion',
		},
		width: '100%',
	};

	vm.graphEvents = {
		blurNode: function () {
			$element.find('canvas')[0].style.cursor = 'default';
		},
		click: function (params) {
			var nodeId = params.nodes[0];

			if (typeof nodeId !== 'undefined') {
				onNodeClick(getNode(nodeId));
			}
		},
		hoverNode: function () {
			$element.find('canvas')[0].style.cursor = 'pointer';
		},
	};

	vm.$onChanges = function (changes) {
		if (changes.dependencyTree) {
			initTree(changes.dependencyTree.currentValue);
		}
	};

	function initTree(tree) {
		if (typeof tree !== 'object' || !Array.isArray(tree.Objects) || !Array.isArray(tree.Dependencies) || tree.Objects.length === 0) {
			vm.graphLoaded = false;
			return;
		}

		onNodeClick(tree.Objects[0]);

		getImages(tree.Objects).then(function () {
			var nodes = new VisDataSet(
				tree.Objects.map(function (object) {
					return {
						id: object.ObjectID,
						image: createNode(object),
						shape: 'image',
						title: object.Name,
					};
				})
			);

			var edges = new VisDataSet(
				tree.Dependencies.map(function (dependency) {
					return {
						from: dependency.Parent,
						label: dependency.Info,
						to: dependency.Child,
					};
				})
			);

			vm.graphData = {
				edges: edges,
				nodes: nodes,
			};

			vm.graphLoaded = true;
		});
	}

	function getImages(nodes) {
		var promises = [];

		var defaultMaterialIcons = [];
		var setIcons = [];

		nodes.forEach(function (node) {
			if (node.MainIcon && !images[node.ObjectID]) {
				if (node.MainIcon.indexOf(':') === -1) {
					defaultMaterialIcons.push(node);
				} else {
					setIcons.push(node);
				}
			}
		});

		if (defaultMaterialIcons.length > 0) {
			promises.push(
				getMaterialIcons().then(function (icons) {
					defaultMaterialIcons.forEach(function (node) {
						icons.some(function (icon) {
							if (icon.name === node.MainIcon) {
								images[node.ObjectID] = icon.src;
								return true;
							}
						});
					});
				})
			);
		}

		setIcons.forEach(function (node) {
			if (node.MainIcon && !images[node.ObjectID]) {
				promises.push(loadIconBase64(node.ObjectID, node.MainIcon));
			}
		});

		return $q.all(promises);
	}

	function loadIconBase64(objectId, iconName) {
		var defer = $q.defer();

		$mdIcon(iconName)
			.then(function (iconEl) {
				images[objectId] =
					'<image xlink:href="data:image/svg+xml;base64,' + window.btoa(new XMLSerializer().serializeToString(iconEl)) + '"  x="5px" y="0" width="190px" height="90px"/>';
				defer.resolve();
			})
			.catch(function () {
				defer.resolve();
			});

		return defer.promise;
	}

	async function getMaterialIcons() {
		if (!vm.materialIcons) {
			const svgFont = await themeService.loadSvgIconsFont();
			const div = document.createElement('div');

			div.innerHTML = svgFont;
			const glyphs = div.querySelectorAll('glyph');

			vm.materialIcons = Array.prototype.slice.call(glyphs).map(function (glyph) {
				return {
					name: glyph.attributes['glyph-name'].value,
					src: convertSVGGlyphToPath(glyph),
				};
			});
		}

		return vm.materialIcons;
	}

	function convertSVGGlyphToPath(glyph) {
		var html = glyph.outerHTML;
		if (!glyph.outerHTML) {
			var temp = document.createElement('div');
			var tempNode = glyph.cloneNode(true);
			temp.appendChild(tempNode);
			html = temp.innerHTML;
		}
		var glyphBody = html.split('<glyph')[1].split('></glyph>')[0];

		return '<path fill="#8f8f8f" transform="scale(0.11, 0.11) translate(400) scale(1 -1) translate(0 -1024)" ' + glyphBody + '/>';
	}

	function onNodeClick(object) {
		if (!currentObject || currentObject.ObjectID !== object.ObjectID) {
			$scope.$evalAsync(function () {
				vm.onNodeClick({ object: object });
			});
			currentObject = object;
		}
	}

	function getNode(id) {
		var node;
		vm.dependencyTree.Objects.some(function (object) {
			if (object.ObjectID === id) {
				node = angular.copy(object);
				return true;
			}
		});
		return node;
	}

	function createNode(node, clicked) {
		node = node || {};
		var backgroundColor = clicked ? '#a2b975' : '#ffffff';
		var image = images[node.ObjectID];
		var height = 208; // Image ? 200 : 100;
		var rectangleY = 100;
		var fontFamily = "'Open Sans', sans-serif";
		var fontSize = 16;

		var name = '';
		var nameLinesEncode = mx.components.Utils.htmlEncode(node.Name);
		var nameLines = convertTextToMultiLine(nameLinesEncode);
		var lineHeight = 16;

		nameLines.forEach(function (line, index) {
			name +=
				'<tspan x="0" y="' +
				(height - rectangleY + index * lineHeight) +
				'" fill="#333333" font-family="' +
				fontFamily +
				'" font-size="' +
				fontSize +
				'">' +
				line +
				'</tspan>';
		});

		var nameHeight = (nameLines.length - 1) * lineHeight;

		height += nameHeight;
		rectangleY += nameHeight;

		var svg =
			'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 ' +
			height +
			'" enable-background="new 0 0 200 ' +
			height +
			'" xml:space="preserve" height="' +
			height +
			'" width="200">' +
			'<rect fill="' +
			backgroundColor +
			'" stroke="none" width="200" height="' +
			height +
			'"/>' +
			'<g class="currentLayer">' +
			(image ? image : '') +
			'<rect fill="none" stroke="#222222" stroke-width="2" stroke-linejoin="round" stroke-dashoffset="" fill-rule="nonzero" id="svg_1" x="0" y="' +
			(height - rectangleY) +
			'" width="200" height="' +
			rectangleY +
			'" style="color: rgb(0, 0, 0);" class="" opacity="1" />' +
			'<text transform="matrix(1 0 0 1 19.75 21.75)" font-weight="bold">' +
			name +
			'</text>' +
			'<text transform="matrix(1 0 0 1 19.75 56.375)">' +
			'<tspan x="0" y="' +
			(height - rectangleY + nameHeight) +
			'" fill="#333333" font-family="' +
			fontFamily +
			'" font-size="' +
			fontSize +
			'">' +
			(node.State || 'Unknown') +
			'</tspan>' +
			'<tspan x="0" y="' +
			(height - rectangleY + nameHeight + lineHeight) +
			'" fill="#333333" font-family="' +
			fontFamily +
			'" font-size="' +
			fontSize +
			'">' +
			vm.i18n.committed +
			': ' +
			(node.Agreed || 0).toFixed(2) +
			'%</tspan>' +
			'<tspan x="0" y="' +
			(height - rectangleY + nameHeight + lineHeight * 2) +
			'" fill="#333333" font-family="' +
			fontFamily +
			'" font-size="' +
			fontSize +
			'">' +
			vm.i18n.actual +
			': ' +
			(node.Actual || 0).toFixed(2) +
			'%</tspan>' +
			'</text>' +
			'</g>' +
			'</svg>';

		return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
	}

	function convertTextToMultiLine(text) {
		var maxLength = 22;
		var words = text.split(' ');
		var lines = [];

		lines.push('');

		words.forEach(function (word) {
			if (lines[lines.length - 1].length + word.length < maxLength) {
				lines[lines.length - 1] += ' ' + word;
			} else {
				lines.push(word);
			}
		});

		return lines;
	}
}
